import { useLocalization } from "@tm/localization"
import { useUser } from "@tm/context-distribution"
import { getTitleTypeTextId } from "@tm/utils"
import { Typography, Stack } from "@tm/components"
import { CostEstimationVoucherCustomer, CostEstimationVoucherVehicle } from "@tm/data/vouchers/costEstimations"
import { VoucherDetailsField } from "../../_shared/VoucherDetailsHeader/components/VoucherDetailsField"

type Props = {
    customer?: CostEstimationVoucherCustomer
    vehicle?: CostEstimationVoucherVehicle
    repairShopLogo?: string
}

export function CustomerOverview({ customer, vehicle, repairShopLogo }: Props) {
    const { translateText, formatDate } = useLocalization()
    const userSettings = useUser()?.userSettings
    const titleType = customer && customer.titleType && getTitleTypeTextId(customer.titleType)
    const { companyName, contactInfo, postalAddress } = userSettings?.repairShop || {}

    return (
        <Stack direction="row" justifyContent="space-between">
            <Stack gap={2}>
                <Stack direction="row" gap={2} flexWrap="wrap">
                    <VoucherDetailsField label={translateText(102)} value={customer?.customerNumber} />
                    <VoucherDetailsField label={translateText(118)} value={titleType && translateText(titleType)} />
                    <VoucherDetailsField label={translateText(76)} value={customer?.academicTitle} />
                    <VoucherDetailsField label={translateText(119)} value={customer?.firstName} />
                    <VoucherDetailsField label={translateText(104)} value={customer?.lastName} />
                    <VoucherDetailsField label={translateText(108)} value={customer?.companyName} />
                    <VoucherDetailsField label={translateText(111)} value={customer?.street} />
                    <VoucherDetailsField label={translateText(112)} value={customer?.zip} />
                    <VoucherDetailsField label={translateText(845)} value={customer?.city} />
                </Stack>
                <Stack direction="row" gap={2} flexWrap="wrap">
                    <VoucherDetailsField label={translateText(25)} value={vehicle?.displayName} />
                    <VoucherDetailsField label={translateText(12443)} value={vehicle?.plateId} />
                    <VoucherDetailsField
                        label={translateText(124)}
                        value={vehicle?.initialRegistration ? formatDate(vehicle.initialRegistration, "g") : ""}
                    />
                    <VoucherDetailsField label={translateText(125)} value={vehicle?.mileage} />
                    <VoucherDetailsField label={translateText(101)} value={vehicle?.vin} />
                </Stack>
            </Stack>
            <Stack direction="row" gap={2}>
                {repairShopLogo && <img src={`data:image;base64,${repairShopLogo}`} alt="Repairshop Logo" style={{ maxHeight: "90px" }} />}
                {userSettings && userSettings.repairShop && (
                    <Stack>
                        <Typography variant="h2">{companyName}</Typography>
                        <Typography variant="label">{postalAddress && postalAddress.street}</Typography>
                        <Typography variant="label">{postalAddress && `${postalAddress.zip}, ${postalAddress.city}`}</Typography>
                        <Typography variant="label">{contactInfo && contactInfo.phone}</Typography>
                        <Typography variant="label">{contactInfo && contactInfo.email}</Typography>
                    </Stack>
                )}
            </Stack>
        </Stack>
    )
}
